import React, { useContext, useEffect, useRef } from 'react';
import { message, Button } from 'antd';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import intl from 'react-intl-universal';

import IntlSettingModal, { IntlSettingModalRef } from '@/components/Intl/IntlSettingModal';
import IconFont from '@/components/IconFont';
import { storage } from '@/utils';
import { getCurrentEmployee } from '@/redux/actions/user';
import IntlContext from '@/components/Intl/IntlContext';

import { logoutToLogin } from '@/utils/user';
import { TenantSignStorage } from '@/utils/intl';

import ChooseShop, { ImodalRef } from './components/ChooseShop';
import LoginWrapper from './components/LoginWrapper';
import styles from './index.module.scss';

const win: any = window;

interface ILoginRes {
  shops: Array<any>;
  hasGroupPermission: boolean;
}

function Login(props) {
  const history = useHistory();

  const chooseShopRef = useRef<ImodalRef>();
  const intlModalRef = useRef<IntlSettingModalRef>();
  const intlCtx = useContext(IntlContext);

  // 商户logo
  const logo = TenantSignStorage.getLocalConfig()?.icon3x;

  const checkShopCount = ({ shops, hasGroupPermission }) => {
    // 不存在集团权限
    if (!hasGroupPermission && Array.isArray(shops) && shops.length) {
      if (shops.length === 1) {
        // 只有一个门店直接跳首页
        storage.set('commonCode', shops[0]?.commonCode);
        history.replace('/room-state/realtime');
      } else {
        chooseShopRef.current.openModal();
      }
    }
    // 存在集团权限
    if (hasGroupPermission) chooseShopRef.current.openModal();
  };

  useEffect(() => {
    try {
      // 多标签 改变标签标题
      win?.electron?.ipcRenderer?.changeTabTitle(intl.get('login_electron_tit1'));
    } catch (error) {
      //
    }
    intlCtx.initTenantConfig({ isUserLogin: false });
  }, []);

  // 登录成功
  const handleLoginSuccess = (data) => {
    storage.set('token', data.accessToken);
    props.getCurrentEmployee().then((res: ILoginRes) => {
      if (Array.isArray(res.shops) && res.shops.length) {
        message.success(intl.get('login_msg1'));
        checkShopCount(res);
      } else {
        // 异常提示
        chooseShopRef.current.openNoPermissionModal();
      }
    });
  };

  // 国际化配置
  const showIntlSettingModal = () => {
    intlModalRef.current.showModal();
  };

  return (
    <div className={styles.loginContainer}>
      <ChooseShop
        ref={chooseShopRef}
        onCancel={() => {
          logoutToLogin();
        }}
      />
      <div className={styles.loginWrapper}>
        <div className={styles.loginWelcome}>
          {/* <div className={styles.loginLogo} /> */}
          <img src={logo} alt="logo" className={styles.logo} />
          <div className={styles.loginWelcomeText}>
            <p className={styles.loginWelcomeText1}>{intl.get('login_welcome')}</p>
            <p>{intl.get('app_wy_pms')}</p>
          </div>
        </div>
        <LoginWrapper onLoginSuccess={handleLoginSuccess} />
      </div>
      <div className={styles.intlSettingWrapper}>
        <Button type="text" onClick={showIntlSettingModal} icon={<IconFont type="icon-setting" />}>
          {intl.get('login_intl_setting')}
        </Button>
      </div>
      <IntlSettingModal type="local" ref={intlModalRef} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    ...state.login,
    ...state.user,
  };
};

export default connect(mapStateToProps, {
  getCurrentEmployee,
})(Login);
